import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import EmptyBoxVector from '@/utils/vectors/EmptyBoxVector'
import { Button, Typography } from 'antd'
import Link from 'next/link'
import { EmptyStateStyles } from './styles'

export const ErrorPdp = () => {
  const locale = getLocale() || defaultLocale
  const { productDetail: copy } = locale
  return (
    <EmptyStateStyles className="broken">
      <EmptyBoxVector width={227} />
      <Typography.Title level={2} className="broken__title">
        {copy?.broken?.title}
      </Typography.Title>
      <Typography.Paragraph
        style={{ color: 'var(--color-black1)' }}
        className="broken__subtitle"
      >
        {copy?.broken?.subtitle}
      </Typography.Paragraph>
      <Link href="/" className="broken__go-home-btn">
        <Button type="primary" style={{ width: '100%' }}>
          {copy?.broken?.btnTxt}
        </Button>
      </Link>
    </EmptyStateStyles>
  )
}
